<template>
    <div>
        <v-server-table ref="equipmentTable" url="/equipment/list" :columns="columns" :options="options">
            <router-link slot="equipment_id" slot-scope="props" :to="`/equipment/tracking/${props.row.equipment_id}/edit`" title="Check In Equipment" class="btn btn-sm btn-secondary">
                Check In
            </router-link>

            <template slot="equipment_type_name" slot-scope="props">
                {{ props.row.equipment_type_name }}
            </template>

            <template slot="equipment_name" slot-scope="props">
                <router-link :to="`/equipment/view/${props.row.equipment_id}`" title="View Equipment" v-if="props.row.equipment_name">
                    {{ props.row.equipment_name }}
                </router-link>
            </template>

            <template slot="LastName" slot-scope="props">
                <template v-if="props.row.LastName">{{ props.row.FirstName + ' ' + props.row.LastName }}</template>
                <template v-if="props.row.EmployeeLastName">{{ props.row.EmployeeFirstName + ' ' + props.row.EmployeeLastName }}</template>
            </template>

            <template slot="issue_date" slot-scope="props">
                <template v-if="props.row.issue_date">{{ props.row.issue_date | moment("MM/DD/YYYY") }}</template>
            </template>

            <template slot="calibrate_date" slot-scope="props">
                <template v-if="props.row.calibrate_date">{{ props.row.calibrate_date | moment("MM/DD/YYYY") }}</template>
            </template>

            <template slot="return_date" slot-scope="props">
                <template v-if="props.row.return_date">{{ props.row.return_date | moment("MM/DD/YYYY") }}</template>
            </template>

            <template slot="purchase_date" slot-scope="props">
                <template v-if="props.row.purchase_date">{{ props.row.purchase_date | moment("MM/DD/YYYY") }}</template>
            </template>

            <template slot="JobsiteName" slot-scope="props">
                <router-link :to="`/jobsites/view/${props.row.jobsite_id}`" v-if="props.row.jobsite_id">
                    {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
                </router-link>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: ['assetType', 'assetId'],
        data: function() {
            return {
                exportingTable: false,
                columns: [
                    'equipment_id',
                    'equipment_name',
                    'equipment_type_name',
                    'LastName',
                    'model_number',
                    'serial_number',
                    'issue_date',
                    'calibrate_date',
                    'return_date',
                    'purchase_date',
                    'JobsiteName',
                ],
                options: {
                    headings: {
                        equipment_id: 'ID',
                        equipment_type_name: 'Type',
                        equipment_name: 'Name',
                        LastName: 'Assignee',
                        model_number: 'Model#',
                        serial_number: 'Serial#',
                        issue_date: 'Issued',
                        calibrate_date: 'Calibrated',
                        return_date: 'Return',
                        purchase_date: 'Purchased',
                        JobsiteName: 'Jobsite',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'issue_date',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('checkedEquipmentListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //INclude the asset
                        data.assetType = this.assetType;
                        data.assetId = this.assetId;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'equipment_id',
                },
            }
        },

        methods: {

        },
    }
</script>
